/* eslint-disable no-return-assign */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavDropdown, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import CaptureClicksV2 from '../../components/CaptureClicksV2';
import Image from '../../../shared/components/Image';
import { NavigationSubMenu } from './NavigationSubMenu';
import NavigationContentMenu from './NavigationContentMenu';
import NavIcon from './NavIcon';
import { ROUTE_PREFIXES, SEGMENT_EVENTS } from '../../../shared/Constants';
import { FeatureFlagContext } from '../../../../common/FeatureFlagContext';


class Navigation extends Component {
    static propTypes = {
        isVerbAdmin: PropTypes.bool,
        isContentAuthor: PropTypes.bool,
        isCompanyReportViewer: PropTypes.bool,
        isVerbReportViewer: PropTypes.bool,
        isAuthenticated: PropTypes.bool,
        isContentAdmin: PropTypes.bool,
        loggedInUser: PropTypes.object,
        userCompany: PropTypes.object,
        currentProfile: PropTypes.object,
        isAccountOwner: PropTypes.bool,
        isContentReviewer: PropTypes.bool,
        isInstructionalAdmin: PropTypes.bool,
        isInstructionalContentAdmin: PropTypes.bool,
        isInstructionalReportViewer: PropTypes.bool,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }),
        activeUserTeams: PropTypes.array,
        history: PropTypes.object,
        handleConfirmationModal: PropTypes.func,
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            forceClose: false,
            activePage: '',
            confirmationModal: false,
            currentPath: ''
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    handleDropdownClick = () => {
        if (this.state.dropdownOpen) {
            this.setState({
                dropdownOpen: false
            });
        } else {
            this.setState({
                dropdownOpen: true
            });
        }
    };

    resize = () => this.forceUpdate();

    handleNavigation = (path, trackingEvent = null) => {
        const { teamsUnsavedFlag, history, location, handleConfirmationModal } = this.props;

        const teamsRegex = /^\/admin\/editcompany\/[^\/]+\/teams(\/[^\/]+)?$/;
        const isCurrentPathsTeams = teamsRegex.test(location.pathname);

        if (isCurrentPathsTeams && teamsUnsavedFlag) {
            this.setState({
                confirmationModal: true,
                currentPath: path
            });
            handleConfirmationModal(true);
        } else {
            history.push(path);
            handleConfirmationModal(false);
        }
    }

    confirmActionFunction = () => {
        const { currentPath } = this.state;
        const { handleConfirmationModal } = this.props;
        this.setState({
            confirmationModal: false,
        });
        
        this.props.setUnsavedChanges(false);
        this.props.history.push(currentPath);
        handleConfirmationModal(false);
    }

    confirmCancelFunction = () => {
        this.setState({
            confirmationModal: false,
        });
        return;
    }

    render() {
        const { dropdownOpen } = this.state;
        const {
            currentProfile,
            userCompany,
            activeUserTeams,
            loggedInUser,
            isAuthenticated,
            isVerbAdmin,
            isAccountOwner,
            isContentAuthor,
            isContentReviewer,
            isContentAdmin,
            isCompanyReportViewer,
            isVerbReportViewer,
            isInstructionalAdmin,
            isInstructionalContentAdmin,
            isInstructionalReportViewer,
            location: { pathname }
        } = this.props;

        const explorePageActive = pathname.startsWith(ROUTE_PREFIXES.EXPLORE);
        const desktopDropdownImage = (
            <NavIcon isSelected={dropdownOpen === true} hiddenXS={false} iconClass={'fa-bars user-icon'} />
        );
        if (
            window.location.href.includes('welcome/') ||
            window.location.href.includes('learningsampler/')
        ) {
            return null;
        }
        return (
            <FeatureFlagContext.Consumer>
                {
                    featureFlagData => 
                        <CaptureClicksV2>
                            <div className={'navigation'}>
                                <Navbar collapseOnSelect fixedtop={'true'} className={'topNav'}>
                                    <div className={'container'}>
                                        <Navbar.Toggle aria-controls={'responsive-navbar-nav'} />
                                        <Navbar.Collapse id={'responsive-navbar-nav'}>
                                            <Nav className={'desktop-nav-items me-auto'}>
                                                <NavigationContentMenu
                                                    userCompany={userCompany}
                                                    isVerbAdmin={isVerbAdmin}
                                                    isAccountOwner={isAccountOwner}
                                                    isCompanyReportViewer={isCompanyReportViewer}
                                                    isVerbReportViewer={isVerbReportViewer}
                                                    pathName={pathname}
                                                    loggedInUser={loggedInUser}
                                                    renderForMobile={true}
                                                    activeUserTeams={activeUserTeams}
                                                    featureFlagData={featureFlagData}
                                                    handleNavigation={this.handleNavigation}
                                                    confirmActionFunction={this.confirmActionFunction}
                                                    confirmCancelFunction={this.confirmCancelFunction}
                                                    confirmationModal={this.state.confirmationModal}
                                                    {...this.props}
                                                />
                                            </Nav>
                                            <Nav className={'actions-nav-bar'}>
                                                <NavItem className={'navbar-section explore-link'}>
                                                    <Nav.Link eventKey={5} onClick={ () => this.handleNavigation('/explore', SEGMENT_EVENTS.NAV_EXPLORE)}>
                                                        <NavIcon
                                                            hiddenXS={false}
                                                            isSelected={explorePageActive}
                                                            iconClass={'fa-search'}
                                                        />
                                                    </Nav.Link>
                                                </NavItem>

                                                {/* {loggedInUser._id ? (
                                                    <NavItem
                                                        className={'navbar-section beamerTrigger'}
                                                    >
                                                        <NavIcon hiddenXS={false} iconClass={'fal fa-bell'} key={'adminIcon'} />
                                                    </NavItem>
                                                ) : null} */}
                                                {/* <NavDropdown
                                                    open={dropdownOpen}
                                                    title={desktopDropdownImage}
                                                    id={'basic-nav-dropdown'}
                                                    className={'navbar-section hamburger-dropdown'}
                                                    onToggle={this.handleDropdownClick}
                                                    align={'end'}
                                                >
                                                    <NavigationSubMenu
                                                        currentProfile={currentProfile}
                                                        userCompany={userCompany}
                                                        activeUserTeams={activeUserTeams}
                                                        isAuthenticated={isAuthenticated}
                                                        isAccountOwner={isAccountOwner}
                                                        isVerbAdmin={isVerbAdmin}
                                                        renderForMobile={true}
                                                    />
                                                </NavDropdown> */}
                                            </Nav>
                                        </Navbar.Collapse>
                                    </div>
                                </Navbar>
                            </div>
                        </CaptureClicksV2>
                }
            </FeatureFlagContext.Consumer>
        );
    }
}

export default Navigation;
